import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {QueryUsersForInternalArgs as QueryArgs} from "@irati/types"

export interface QueryUsersArgs extends QueryArgs {
  includeBusiness?: boolean
}

const query = gql`
  query UsersForInternal(
    $cursor: String
    $enabled: Boolean
    $includeBusiness: Boolean!
    $lastNameCharacter: String
    $limit: Int
    $offset: Int
    $role: String
    $searchString: String
    $sort: String
  ) {
    usersForInternal(
      cursor: $cursor
      enabled: $enabled
      lastNameCharacter: $lastNameCharacter
      limit: $limit
      offset: $offset
      role: $role
      searchString: $searchString
      sort: $sort
    ) {
      total
      cursor
      results {
        uuid
        firstname
        lastname
        metadata {
          createdAt
        }
        isEnabled
        email
        business @include(if: $includeBusiness) {
          uuid
          businessName
        }
      }
    }
  }
`

export const usersForBusinessKey = getQueryNames(query)[0]

export default query
